
import { Vue, Component, Prop, Model, Emit } from 'vue-property-decorator';
import BadgeInfoIcon from '@/components/icons/BadgeInfoIcon.vue';
import TableInfo from '@/components/icons/TableInfo.vue';
import Tooltip from '@/components/common/Tooltip.vue';
import TooltipVariants from '@/entities/TooltipVariants';
@Component({
	components: {
		BadgeInfoIcon,
		Tooltip,
		TableInfo,
	},
})
export default class DataTable extends Vue {
	@Prop({ type: Array, required: true }) headers!: Array<{
		text: string;
		value: string;
		isLink?: boolean;
		badge?: boolean;
		action?: boolean;
		sort?:boolean
		icon:any
	}>;

	@Prop({ type: Array, required: true }) data!: Array<Record<string, any>>;
	@Prop({ type: Array, default: () => [] }) actions;
	@Prop({ type: Boolean, default: false }) showCheckboxes!: boolean;
	@Prop({ type: Boolean, default: false }) hoursTable!: boolean;
	@Prop({ type: String, default: "" }) rate!: string;
	@Prop({ default: null }) readonly sort_direction!: string;
	@Prop({ default: null }) readonly sort_by!: string;

	@Model('change', { type: Array }) selected!: Array<any>;
	openDropdown: number | null = null;
	TooltipVariants = TooltipVariants;
			sortColumn(field: string) {
		if (this.sort_direction === 'desc') {
			this.$emit('sort', {});
		} else {
			const newOrder: string =
				this.sort_by === field && this.sort_direction === 'asc'
					? 'desc'
					: 'asc';
			this.$emit('sort', { sortBy: field, sortDirection: newOrder });
		}
	}
	showNotes(item){
		this.$emit("showNote", item);
	}
	toggleDropdown(itemId) {
		this.openDropdown = this.openDropdown === itemId ? null : itemId;
	}

	handleDropdownAction(actionName, item) {
		this.$emit('action', { actionName, item });
		this.closeDropdown();
	}
	get areAllApprovedSelected() {
		const approvedItems = this.data.filter(
			(item) => item.status === 'APPROVED'
		);
		return approvedItems.every((approvedItem) =>
			this.isSelected(approvedItem)
		);
	}
	closeDropdown() {
		this.openDropdown = null;
	}

	mounted() {
		document.addEventListener('click', this.handleOutsideClick);
	}

	beforeDestroy() {
		document.removeEventListener('click', this.handleOutsideClick);
	}

	handleOutsideClick(event) {
		if (this.openDropdown !== null && !this.$el.contains(event.target)) {
			this.closeDropdown();
		}
	}
	canShowCheckbox(item) {
		return item.status === 'APPROVED';
	}
	isSelected(item) {
		return this.selected.some(
			(selectedItem) => selectedItem.id === item.id
		);
	}
	@Emit('change')
	handleHeaderCheckboxChange(event) {
		return event.target.checked
			? this.data.filter((item) => item.status === 'APPROVED')
			: this.selected.filter((item) => item.status !== 'APPROVED');
	}
	@Emit('change')
	handleRowCheckboxChange(item) {
		const isSelected = this.isSelected(item);
		let newSelected;
		if (isSelected) {
			newSelected = this.selected.filter(
				(selectedItem) => selectedItem.id !== item.id
			);
		} else {
			newSelected = [...this.selected, item];
		}
		return newSelected;
	}
	emitAction(actionName, item) {
		if (actionName === 'action') {
			this.toggleDropdown(item.id);
			return;
		}
		this.$emit(actionName, item);
	}
	status(value) {
		switch (value) {
			case 'PENDING':
				return 'Pending Approval';
			case 'APPROVED':
				return `${this.hoursTable ? ' Approved' : 'Approved'}`;
			case 'REJECTED':
				return `Invoice Rejected`;
			case 'PAID':
				return 'Paid';
			case 'PAYMENT SEND':
				return 'Payment Sent';
			case 'CANCEL':
				return 'Cancelled';

			default:
				break;
		}
		return `${value?.toLowerCase()?.replace(/\s+/g, '-')}`;
	}
  // This JavaScript code adds the 'safari' class to the body element when the browser is Safari.
  isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    document.body.classList.add('safari');
  }
}
